import { useTranslation } from '@/hooks/useTranslation';
import { Suspense } from 'react';

interface TranslationSuspenseProps {
  children: React.ReactNode;
  fallback?: React.ReactNode;
}

/**
 * Loading component for translation suspense
 */
function TranslationLoading() {
  const { t } = useTranslation();

  return (
    <div className='flex items-center justify-center min-h-screen'>
      <div className='flex flex-col items-center space-y-4'>
        <div className='animate-spin rounded-full h-8 w-8 border-b-2 border-primary'></div>
        <p className='text-sm text-muted-foreground'>
          {t('loadingTranslations')}
        </p>
      </div>
    </div>
  );
}

/**
 * Suspense wrapper for translation loading
 * Provides a fallback UI while translations are being loaded
 */
export function TranslationSuspense({
  children,
  fallback = <TranslationLoading />,
}: TranslationSuspenseProps) {
  return <Suspense fallback={fallback}>{children}</Suspense>;
}

export default TranslationSuspense;
